export default __webpack_public_path__ + "static/media/Castillo.024a6be6.webp";